module.exports = __webpack_public_path__ + "img/panorama.030eb38.jpg";